"use client";

import { Autocomplete } from "../Autocomplete/Autocomplete";
import { AutocompleteItem } from "../Autocomplete/AutocompleteItem";
import { COUNTRY_OPTIONS } from "./countries";

export interface CountrySelectProps {
  value?: string | null;
  onChange?: (country: string | null) => void;
  onBlur?: () => void;
  label?: string;
  placeholder?: string;
  name?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  isInvalid?: boolean;
  errorMessage?: string;
  className?: string;
}

export function CountrySelect({
  value,
  onChange,
  onBlur,
  label = "Country",
  placeholder = "Select a country",
  name,
  isRequired,
  isDisabled,
  isInvalid,
  errorMessage,
  className,
}: CountrySelectProps) {
  return (
    <Autocomplete
      className={className}
      errorMessage={errorMessage}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      isRequired={isRequired}
      label={label}
      name={name}
      onBlur={onBlur}
      onSelectionChange={(key) => onChange?.(key === null ? null : String(key))}
      placeholder={placeholder}
      selectedKey={value ?? null}
      variant="bordered"
    >
      {COUNTRY_OPTIONS.map((country) => (
        <AutocompleteItem key={country}>{country}</AutocompleteItem>
      ))}
    </Autocomplete>
  );
}
